import React from 'react'
import { useHistory } from 'react-router-dom'
import styled from '@emotion/styled/macro'
import QueryAccount from 'components/QueryAccount'
import useDarkMode from 'use-dark-mode'
import mq from 'mediaQuery'
import CheckMarkIcon from 'assets/checkmarkicon'

const DomainList = ({ data }) => {
  const history = useHistory()
  const darkMode = useDarkMode()
  const isDark = darkMode.value

  const onRedirect = domainName => {
    const name = domainName.split('.')
    history.push(`/search/${name[0]}`)
  }

  return (
    <QueryAccount>
      {({ account }) => {
        if (account === '0') {
          return (
            <H5Bold style={{ color: '#E7303C' }}>
              {data?.connectMetamaskText}
            </H5Bold>
          )
        }

        const domains = localStorage.getItem(`domains_ans_${account}`)

        if (!domains)
          return <H5Bold isDark={isDark}>{data?.noDomainsText}</H5Bold>
        else {
          const lists = JSON.parse(domains)
          return (
            <div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '0 24px 20px'
                }}
              >
                <H5Bold isDark={isDark}>{data?.NameTitle}</H5Bold>
              </div>
              {lists.map((list, id) => (
                <Wrap
                  key={id}
                  isDark={isDark}
                  onClick={() => onRedirect(list.domainName)}
                >
                  <Flex>
                    <CheckMarkIcon />
                    <H5Bold isDark={isDark}>{list.domainName}</H5Bold>
                  </Flex>
                </Wrap>
              ))}
            </div>
          )
        }
      }}
    </QueryAccount>
  )
}

export default DomainList

const Flex = styled('div')`
  display: flex;
  align-items: center;
  max-width: 123px;

  ${mq.medium`
    max-width: inherit;
    width: auto;
  `}

  svg {
    margin-right: 5px;
    width: 20px;
    height: 20px;

    ${mq.medium`
      margin-right: 10px;
      width: 24px;
      height: 24px;
    `}
  }
`

const Wrap = styled('div')`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin: -1px;
  padding: 24px;
  background: ${({ isDark }) => (isDark ? '#282828' : '#fff')};
  border: ${({ isDark }) =>
    isDark ? '0.5px solid #181818' : '0.5px solid #000000'};
  cursor: pointer;

  ${mq.medium`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `}
`

const H5Bold = styled('div')`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 133.4%;
  text-align: center;
  color: ${({ isDark }) => (isDark ? '#fff' : '#181818')};
  text-overflow: ellipsis;
  overflow: hidden;
  ${mq.medium`
  font-weight: 700;
  font-size: 24px;
  `}
`

const H6Bold = styled(H5Bold)`
  font-weight: 500;
  font-size: 14px;
  margin-left: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: right;

  ${mq.medium`
    font-size: 24px;
  `}
`
